import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import Route66Network from "@/pages/Route66Network";

export const Route = createFileRoute("/route-66-rv-network")({
  head: () => pageHead({
    title: 'Route 66 RV Network',
    description: 'Rex & Sons RVs is a proud Route 66 RV Network dealer — enjoy nationwide service priority, roadside assistance and member benefits.',
    path: '/route-66-rv-network',
  }),
  component: Route66Network,
});
